<template>
  <div class="modal-xm modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Изменение тарифа</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="regionData" class="modal-body">
        <div class="alert alert-success my-1" v-if="this.region.subscription">
          Выбранный тариф: {{this.region.subscription}}
        </div>
        <div class="alert alert-success my-1" v-if="this.region.current_subscription">
          Действующий тариф: {{this.region.current_subscription}}
        </div>
        <h4>Выбранный тариф</h4>
        <server-select
                  class="select-machines-orders-ingredients-create"
                  v-model="selectedSubscription"
                  :custom-label="tariffName"
                  :endpoint="`billing/regions/tariffs-list`"
                />
        <h4>Действующий тариф</h4>
        <server-select
                  class="select-machines-orders-ingredients-create"
                  v-model="selectedCurrentSubscription"
                  :custom-label="tariffName"
                  :endpoint="`billing/regions/tariffs-list`"
                />
      </div>
      <div class="alert alert-danger my-1" v-if="validationError">
        {{validationError}}
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <btn-action
          class="btn btn-primary"
          @click="save"
        >Изменить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import {pick, cloneDeep} from 'lodash'

  export default {
    props: ['region'],
    data () {
      return {
        selectedSubscription: null,
        selectedCurrentSubscription: null,
        regionData: {
            region: this.region
        },
        validationError: '',
        balance: 0,
      }
    },
    methods: {
      tariffName (tariff) {
        return tariff.name
      },
      save () {
        return api.post('billing/regions/edit-tariff', {
          subscription: this.selectedSubscription.code,
          current_subscription: this.selectedCurrentSubscription.code,
          region_id: this.region.id,
        })
          .then(({data}) => {
              this.hide(false)
              window.alert(`Тарифы успешно измененёны \n Выбранный: ${this.selectedSubscription.name} \n Действующий: ${this.selectedCurrentSubscription.name}`)
            })
          .catch(this.handleError)
      },
      hide (refresh = false) {
        this.$emit('hide', {
          refresh: refresh,
        })
      },
      handleError (error) {
        if (error.response && error.response.status === 422) {
          let obj = error.response.data.validation
          this.validationError = obj[Object.keys(obj)[0]][0]
        } else {
          throw error
        }
      },
    },
    mounted () {
      if (this.user) {
        this.regionData = pick(this.user, ['count'])
      } else {
        this.regionData = {
            count: '',
          }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/billing/modals/region-edit-tariff.vue